import React from 'react';
import styles from './consultancyStep.module.css';

interface SectionTitleProps {
  children: React.ReactNode;
}

const SectionTitle: React.FC<SectionTitleProps> = ({ children }) => (
  <h1 className={styles.sectionTitle}>{children}</h1>
);

export default SectionTitle;
